import { PaymentData, ApplePayConfiguration } from '@adyen/adyen-web';

import { EPaymentProvider, PaymentMethod } from '../../../../../../contracts';

export enum AdyenCheckoutErrorTypes {
  NETWORK_ERROR = 'NETWORK_ERROR',
  CANCEL = 'CANCEL',
  IMPLEMENTATION_ERROR = 'IMPLEMENTATION_ERROR',
  API_ERROR = 'API_ERROR',
  ERROR = 'ERROR',
  SCRIPT_ERROR = 'SCRIPT_ERROR',
  SDK_ERROR = 'SDK_ERROR',
}

export const APPLE_PAY_CONFIG: ApplePayConfiguration = {
  isExpress: true,
  showPayButton: true,
  requiredBillingContactFields: ['email'],
  requiredShippingContactFields: ['email'],
  domainName: getTopLevelDomain(),
};

export interface ApplePayPaymentDetailsRef {
  email: string;
  paymentMethodDetails: ApplePayJS.ApplePayPaymentMethod;
}

export function createAdyenApplePayFinalizeRequestBody(
  AdyenPaymentMethod: PaymentData,
  applePaymentDetails: ApplePayPaymentDetailsRef,
  ACPaymentMethod: PaymentMethod,
): any {
  return {
    paymentProvider: EPaymentProvider.adyen,
    receipt_email: applePaymentDetails.email,
    paymentMethodDisplayName: ACPaymentMethod?.paymentMethodDisplayName!,
    paymentMethodId: ACPaymentMethod?.id!,
    params: {
      paymentMethod: AdyenPaymentMethod.paymentMethod,
      paymentMethodDetails: applePaymentDetails.paymentMethodDetails,
    },
  };
}

function getTopLevelDomain(): string {
  try {
    const topLevelUrl =
      window.location !== window.parent.location ? document.referrer : document.location.href;
    if (!topLevelUrl) {
      return new URL(document.location.href).hostname;
    }
    return new URL(topLevelUrl).hostname;
  } catch {
    return new URL(document.location.href).hostname;
  }
}
